module.exports = __webpack_public_path__ + "static/media/arrowDownGray.3f295741.svg";